/** Buyer loan hub + setup; lives under `/loan` with secondary nav in the header. */
export const LOAN_PATH = {
  hub: '/loan',
  loanType: '/loan/loan-type',
  qualifications: '/loan/qualifications',
  loanStatus: '/loan/loan-status',
  documents: '/loan/documents',
} as const;

export const LOAN_TAB_ITEMS: ReadonlyArray<{
  label: string;
  path: string;
  tabId: string;
}> = [
  { label: 'Loan type', path: LOAN_PATH.loanType, tabId: 'loan-tab-0' },
  {
    label: 'Loan qualifications',
    path: LOAN_PATH.qualifications,
    tabId: 'loan-tab-1',
  },
  { label: 'My applications', path: LOAN_PATH.hub, tabId: 'loan-tab-2' },
  { label: 'Loan status', path: LOAN_PATH.loanStatus, tabId: 'loan-tab-3' },
  { label: 'Documents', path: LOAN_PATH.documents, tabId: 'loan-tab-4' },
];

export function isLoanFlowPath(pathname: string): boolean {
  return pathname === '/loan' || pathname.startsWith('/loan/');
}
